import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MovingComponent } from "react-moving-text";
import { ContextData } from '../../../../context/Context';
import axios from 'axios';
import baseUrl from '../../../../BaseURL';

import { 
    School as SchoolIcon, 
    Apps as AppsIcon, 
    DriveFolderUpload as DriveFolderUploadIcon, 
    FolderShared as FolderSharedIcon, 
    ContactSupport as ContactSupportIcon, 
    Receipt as ReceiptIcon, 
    DynamicFeed as DynamicFeedIcon 
} from '@mui/icons-material';

import FormLoaderStep from './FormLoaderStep';
import { Getrequest } from '../../../../context/AxiosRequest';
import PopUpAlertDialogue from './ProcessContents/SectionContent/PopUpAlertDialogue';
import { toast } from 'react-toastify';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ApplyingType from './ProcessContents/AppyingType';
import NottificationBell from './NottificationBell';
import { Button } from '@mui/material';
import ReturnApplication from './ReturnApplication';
import GetPersonData from '../../../../context/GetPersonData';



function ScholarshipNotice() {
    return (
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
            <p className="font-bold">Scholarship Notice</p>
            {/* notice scholarship component is under construction */}
            <p>
                Dear Applicant, please be informed that the scholarship application process is currently under maintenance. We apologize for any inconvenience this may cause and appreciate your understanding. Please check back later for updates on the scholarship application process. or contact support team for more information.
            </p>
        </div>
    );
}


function FormProcessHome() {

  
    const Navigate = useNavigate();
    const { UserTokens, ReloadBioForms,accesstoken,Value ,GlobalLoader} = useContext(ContextData);
    const [Data, setData] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [reloader,setreloader] = useState(false)
    const [DocDataSet, setDocDataSet] = React.useState(null);
    const [UploadedDocList,setUploadedDocList] = useState(null)
    const [qualification_type,setqualification_type] = useState(null)
    const [resdentialType,setresdentialType] = useState(null)
    const [Alertvalues,setAlertvalues] = useState({

        headertext: "",
        content: ""
    })
    const [Check_if_pending,setCheck_if_pending] = useState(false)
    

      const [formData, setFormData] = useState({
        bioData: {
          fname: "",
          md_name:"",
          lname: "",
          d_o_b: "",
          email: "",
          mobileNumber: "",
        },
        education: {
          matric_num: "",
          faculty: "",
          deparment: "",
          gpa: "",
        },
        origin: {
          state_of_origin: "",
          local_government: "",
          home_address: "",
        },
        parentsInfo: {
          father_full_name: "",
          mother_full_name: "",
          guardian_valid_mobile: "",
        },
    
        bank: {
           bank_name : "",
           account_number : "",
           account_name : ""
        }
        
    
    
      });
      

    useEffect(() => {

        async function FetchData() {
            const response = await Getrequest(`/auth/get_bio/${UserTokens}`,accesstoken)
            setData(response.bioProgressStatus);
        }
        FetchData();
    }, [ReloadBioForms]);



 React.useEffect(() => {

    async function FetchData() {

         const response = await Getrequest(`/auth/get_upload_doc`,accesstoken)
         setDocDataSet(response)
    }
    FetchData();
  }, [reloader]);


    useEffect(()=>{
      

        async function FetchData(){
                //  setLoader(true)  
    
            const response = await Getrequest(`/auth/get_bio/${UserTokens}`,accesstoken)
             
                  if(response){  

                     setUploadedDocList(response?.applicant_doc_data)
                     setqualification_type(response.edu_data[0]?.applying_for_type)
                     setresdentialType(response.bio_data[0]?.resdential_type)

                      setFormData((prev) => ({
                             ...prev,
                             bioData: {
                               fname: response.bio_data[0]?.fname,
                               lname: response.bio_data[0]?.lname,
                               d_o_b: response.bio_data[0]?.d_o_b,
                               email: response.bio_data[0]?.email,
                               mobileNumber: response.bio_data[0]?.mobileNumber,
                             },
                             origin: {
                               state_of_origin: response.demography_data[0]?.state_of_origin,
                               local_government: response.demography_data[0]?.local_gov,
                               home_address: response.demography_data[0]?.home_address ,
                             },
                             parentsInfo: {  
                               father_full_name: response.parent_data[0]?.father_full_name,
                               mother_full_name: response.parent_data[0]?.mother_full_name,
                               guardian_valid_mobile: response.parent_data[0]?.guardian_valid_mobile,
                             },
                             education: {

                               matric_num: response.edu_data[0]?.matric_num,
                               faculty: response.edu_data[0]?.faculty,
                               deparment: response.edu_data[0]?.deparment,
                               gpa: response.edu_data[0]?.gpa,
                               university: response.edu_data[0]?.university,
                               current_level : response.edu_data[0]?.current_level,
                               manual_university : response.edu_data[0]?.manual_university,
                               manual_university_state : response.edu_data[0]?.manual_university_state
                               
                             },
                             bank:{
                                bank_name: response.bank_details_data[0]?.bank_name,
                                account_number : response.bank_details_data[0]?.account_number,
                                account_name : response.bank_details_data[0]?.account_name
                                
                             }
                             
                           })); 

                  }
            
             
        }FetchData()
    
    
    },[reloader])



     const NavigateFunc = (route,label) =>{
         
           setreloader(!reloader)

/*         if(label === 'Upload Document'){

            const isFormDataComplete = Object.values(formData).every(section => 
            Object.values(section).every(field => field !== "" && field !== null)
            );

            if (!isFormDataComplete) {
                setAlertvalues({
                    headertext : "Attention !!!",
                    content : "Please complete all sections of the Bio Data before uploading documents."
               })
               
            setOpen(true)
            return;

            } 

            Navigate(`/application/${route}`);

        } else if(label ===  'Apply Scholarship'){
          setreloader(!reloader)
              if(!qualification_type && !resdentialType ) return toast.error("Refresh the Page")
             
              const isDocUploaded = DocDataSet.filter(item => ((item.documentType ===  qualification_type  &&  item.resdentialType ===  resdentialType )|| (item.documentType ===  qualification_type  &&  item.resdentialType ===  "both" )))

             // console.log(UploadedDocList.length)
             // console.log(isDocUploaded)
                if(isDocUploaded.length === UploadedDocList.length ){
                  Navigate(`/application/${route}`);

                }else{

                  setAlertvalues({
                    headertext : "Attention !!!",
                    content : "Please upload all required documents in uploads section. note that you can only apply scholarship after your documents is verified"
               })
               
            setOpen(true)
            return;  
                }
             
          
        }else{
            
        } */
        
        Navigate(`/application/${route}`);



    }



       React.useEffect(()=>{
    
              GetPersonData(UserTokens,accesstoken).then(res=>{
                       const verify_status = res.sign_up[0]?.verify_status
                     
                        if(verify_status  === "pending"){
                          Getrequest(`/auth/check_if_returned/${UserTokens}`,accesstoken).then(res=>{
                                             if(res.status){
                                                  setCheck_if_pending(true)
                                             }else if(!res.status){
                                                setCheck_if_pending(false)  
                                             }
                          })
                        }
             })
       },[GlobalLoader])
    


   
    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-600 to-blue-900 text-white flex flex-col items-center p-6">
            {/* Header Section */}
            <div className="w-full max-w-4xl text-center p-6 rounded-xl shadow-lg bg-white text-blue-900">
                <h2 className="text-3xl font-extrabold font-mono">
                    <MovingComponent type="typewriter" dataText={[
                        "Kaduna State Scholarship And Loans Board",
                        "Empowering The Youth For Global Leadership"
                    ]} />
                </h2>
                
            </div>
              <div className="flex justify-center items-center mt-4 mb-4 p-1 bg-white text-blue-900 rounded-lg shadow-md font-serif change_apply_notification_con">
                <div>
                    <b className='pr-4 pl-4 font-extrabold'>Change Application: </b> 
                </div>
                 <div> <ApplyingType /> </div>
               <div className='pr-2 pl-2'>
                 <NottificationBell />
               </div>
               {
                Check_if_pending && 
                <div className='pr-2 pl-2'>
                 <ReturnApplication />
                </div>
               }
        </div>
            {/* Navigation Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-2 w-full max-w-4xl font-serif">
            <PopUpAlertDialogue open={open} setOpen={setOpen} headertext={Alertvalues.headertext} content={Alertvalues.content} />
               {
                Value === "scholarship" ? 
                 <>
                 <ScholarshipNotice />
                {/*   {[
                    { label: "Bio Data", icon: <FolderSharedIcon sx={{ fontSize: "4em" }} />, route: "form_process", extra: <FormLoaderStep value={Data} /> },
                    { label: "Document Upload", icon: <DriveFolderUploadIcon sx={{ fontSize: "4em" }} />, route: "upload_document" },
                    { label: "Preview Application", icon: <AssignmentIcon sx={{ fontSize: "4em" }} />, route: "preview_application" },
                    { label: "Apply Scholarship", icon: <SchoolIcon sx={{ fontSize: "4em" }} />, route: "apply_scholarship" },
                    { label: "My Application", icon: <AppsIcon sx={{ fontSize: "4em" }} />, route: "my_application" },
                 
                ].map((item, index) => (
                     
                    <button  key={index} onClick={() => NavigateFunc(item.route,item.label)}
                        className={`relative flex flex-col items-center justify-center p-6 min-w-[180px] w-full bg-white text-blue-900 shadow-lg rounded-lg hover:scale-105 transition-transform duration-300`}>
                        <div className="mb-2">{item.icon}</div>
                        <p className="text-lg font-bold">{item.label}</p>
                        {item.extra}
                        {
                          ["Bio Data","Loan Application","Upload Document","Preview Application","Apply Scholarship","My Application"].includes(item.label) &&
                        <span className="absolute top-0 right-0 bg-slate-900 p-1 font-extrabold  text-sm text-white">
                          step {index + 1}
                        </span>
                        }
                    </button> 
                ))} */}
                 </>  
                 :
                 <>
                    {[
                    { label: "Bio Data", icon: <FolderSharedIcon sx={{ fontSize: "4em" }} />, route: "form_process", extra: <FormLoaderStep value={Data} /> },
                    { label: "Loan Application", icon: <DynamicFeedIcon sx={{ fontSize: "4em" }} />, route: "loan_application" },
                    { label: "Document(s) Upload", icon: <DriveFolderUploadIcon sx={{ fontSize: "4em" }} />, route: "upload_document" },
                    { label: "Preview Application", icon: <AssignmentIcon sx={{ fontSize: "4em" }} />, route: "preview_application" },
                    { label: "Apply For Loan", icon: <SchoolIcon sx={{ fontSize: "4em" }} />, route: "apply_loan" },
                    { label: "My Application", icon: <AppsIcon sx={{ fontSize: "4em" }} />, route: "my_application" },
                  /*   { label: "Invoice", icon: <ReceiptIcon sx={{ fontSize: "4em" }} />, route: "invioce" }, */
                   /*  { label: "Update Login Details", icon: <DynamicFeedIcon sx={{ fontSize: "4em" }} />, route: "update_login_detail" },
                    { label: "Student Support", icon: <ContactSupportIcon sx={{ fontSize: "4em" }} />, route: "student_support" } */
                ].map((item, index) => (
                     
                    <button  key={index} onClick={() => NavigateFunc(item.route,item.label)}
                        className={`relative flex flex-col items-center justify-center p-6 min-w-[180px] w-full bg-white text-blue-900 shadow-lg rounded-lg hover:scale-105 transition-transform duration-300`}>
                        <div className="mb-2">{item.icon}</div>
                        <p className="text-lg font-bold">{item.label}</p>
                        {item.extra}
                        {
                          ["Bio Data","Loan Application","Document(s) Upload","Preview Application","Apply For Loan","My Application","Apply Scholarship"].includes(item.label) &&
                        <span className="absolute top-0 right-0 bg-slate-900 p-1 font-extrabold  text-sm text-white">
                          step {index + 1}
                        </span>
                        }
                    </button> 
                ))}
                
                 </>
               }
            </div>
            <p className='italic mt-3'>Powered By MastermindTech</p>
        </div>
    );
}

export default FormProcessHome;
